import React, { useState, useEffect } from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;

export default function JWTAuthForm(props) {
  const [aud, setAud] = useState("");
  const [iss, setIss] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [audError, setAudError] = useState(false);
  const [issError, setIssError] = useState(false);
  const [privateKeyError, setPrivateKeyError] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialize form data from props
  useEffect(() => {
    if (props.authData && !isInitialized) {
      const initialAud = props.authData.aud || "";
      const initialIss = props.authData.iss || "";
      const initialPrivateKey = props.authData.privateKey || "";

      setAud(initialAud);
      setIss(initialIss);
      setPrivateKey(initialPrivateKey);
      setIsInitialized(true);

      // Call validation check
      validateForm(initialAud, initialIss, initialPrivateKey);
    } else if (!props.authData && !isInitialized) {
      setIsInitialized(true);
      validateForm("", "", "");
    }
  }, [props.authData, isInitialized]);

  // Validate form and notify parent
  const validateForm = (audValue, issValue, privateKeyValue) => {
    const isAudValid = audValue.trim() !== "";
    const isIssValid = issValue.trim() !== "";
    const isPrivateKeyValid = privateKeyValue.trim() !== "";
    const isFormValid = isAudValid && isIssValid && isPrivateKeyValid;

    if (props.onValidationChange) {
      props.onValidationChange(isFormValid);
    }

    return isFormValid;
  };

  const handleChangeAud = (e) => {
    const value = e.target.value;
    setAud(value);
    setAudError(false);

    const updatedParams = {
      aud: value,
      iss: iss,
      privateKey: privateKey,
    };

    props.handleChangeValues(updatedParams);
    validateForm(value, iss, privateKey);
  };

  const handleChangeIss = (e) => {
    const value = e.target.value;
    setIss(value);
    setIssError(false);

    const updatedParams = {
      aud: aud,
      iss: value,
      privateKey: privateKey,
    };

    props.handleChangeValues(updatedParams);
    validateForm(aud, value, privateKey);
  };

  const handleChangePrivateKey = (e) => {
    const value = e.target.value;
    setPrivateKey(value);
    setPrivateKeyError(false);

    const updatedParams = {
      aud: aud,
      iss: iss,
      privateKey: value,
    };

    props.handleChangeValues(updatedParams);
    validateForm(aud, iss, value);
  };

  return (
    <div>
      <Form.Item
        style={{ marginBottom: "8px" }}
        label="AUD"
        required
        rules={[{ required: true, message: "Please input AUD!" }]}
        validateStatus={audError ? "error" : ""}
      >
        <Input value={aud} onChange={handleChangeAud} disabled={props.isViewOnly} placeholder="Enter AUD value" />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: "8px" }}
        label="ISS"
        required
        rules={[{ required: true, message: "Please input ISS!" }]}
        validateStatus={issError ? "error" : ""}
      >
        <Input value={iss} onChange={handleChangeIss} disabled={props.isViewOnly} placeholder="Enter ISS value" />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: "8px" }}
        label="Private Key"
        required
        rules={[{ required: true, message: "Please input Private Key!" }]}
        validateStatus={privateKeyError ? "error" : ""}
      >
        <TextArea
          rows={3}
          value={privateKey}
          onChange={handleChangePrivateKey}
          disabled={props.isViewOnly}
          placeholder="-----BEGIN PRIVATE KEY-----
Enter your private key here
-----END PRIVATE KEY-----"
        />
      </Form.Item>
    </div>
  );
}
